import { MapMarker } from "../models/map.marker";

export class ItemCluster {
    public map: any;
    public marker?: MapMarker;
    public intoCluster = false;
    public visible = false;
    public lat = 0;
    public lng = 0;

    constructor(map: any, marker: MapMarker) {
        this.map = map;
        this.marker = marker;
        this.lat = marker.position.lat;
        this.lng = marker.position.lng;
    }

    public remove() {
        if (this.marker) {
            this.map.removeMarker(this.marker);
            this.marker = undefined;
        }
    }

    public setVisible(visible: boolean) {
        this.visible = visible;
        this.marker?.setVisibleCluster(visible);
    }

}
